import { HttpErrorResponse } from '@angular/common/http';
import { ToWords } from 'to-words';

const toWords = new ToWords({
  localeCode: 'en-US',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: true,
    currencyOptions: {
      name: 'Dollar',
      plural: 'Dollars',
      symbol: '$',
      fractionalUnit: {
        name: 'Cent',
        plural: 'Cents',
        symbol: '',
      },
    },
  },
});

export const spellNumber = (value: string): string => {
  const numeric = (value ?? '0').toString().replace(/[^0-9.-]/g, '');
  const parsed = Number(numeric || '0');
  return toWords.convert(parsed);
};

export const parseToHumanCase = (value: string): string => {
  if (!value) return '';
  return value
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getErrorMessageFromResponse = (
  error: HttpErrorResponse,
  fallbackMessage: string,
): string => {
  const payload = error.error as { message?: string } | null;
  if (payload && typeof payload.message === 'string') {
    return payload.message;
  }
  return fallbackMessage;
};
